<template>
  <div>
    <Popup v-if="openPop"  v-on:close="openPop=false"/>
    <label-tag :tagArray="[$t('web_record'), $t('app_record')]" :pageIndex="pageIndex" :order="orderBy" v-on:updatedRecord="getRecord" v-on:resetOrder="doOrder"/>
    <div class="px-5 table-responsive" style="overflow: auto; min-height:50vh;font-size:1.25rem">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="order-btn pointer" @click="doOrder('userName')">
              {{$t('username')}}
              <font-awesome-icon class="form_icon" v-show="orderBy==='userName'" :icon="['fas', 'sort-down']" />
            </th>
            <th>{{$t('name')}}</th>
            <th class="order-btn pointer" v-if="mode==='App'" @click="doOrder('goldNum')">
              {{$t('coins')}}
              <font-awesome-icon class="form_icon" v-show="orderBy==='goldNum'" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer" v-if="mode==='App'" @click="doOrder('unlockNum')">
              {{$t('AR_unlocked')}}
              <font-awesome-icon class="form_icon" v-show="orderBy==='unlockNum'" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer" v-if="mode==='App'" @click="doOrder('missionFinishedNum')">
              {{$t('missions_completed')}}
              <font-awesome-icon class="form_icon" v-show="orderBy==='missionFinishedNum'" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer" @click="doOrder('spendTime')">
              {{mode==='Web'?$t('web_study_time'):$t('app_study_time')}}
              <font-awesome-icon class="form_icon" v-show="orderBy==='spendTime'" :icon="['fas', 'sort-down']" />
            </th>
            <th v-if="record.countryId">{{mode==='Web'?$t('web_schedule'):$t('app_schedule')}}</th>
          </tr>
        </thead>
        <tbody style="border-top:1px #cccccc solid;text-align: left;">
          <tr v-for="(item , index) in record.data" :key="index">
            <td>
              {{item.userName}}
            </td>
            <td>
              {{item.realName}}
            </td>
            <td v-if="mode==='App'">
              {{item.goldNum}}
            </td>
            <td v-if="mode==='App'">
              {{item.unlockNum}}
            </td>
            <td v-if="mode==='App'">
              {{item.missionFinishedNum}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
            <td >
              <a v-if="record.countryId" href="javascript:void(0);" @click="goPage(item.userId)">
                {{$t('view')}}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-5" :current="record.pageIndex" :total="record.pageCount" v-on:page="updatePage" />
  </div>
</template>

<script>
import Pagination from '../../../../components/Pagination'
import labelTag from './Label'
import Popup from './Popup'
export default {

  name: 'ARRecordSummary',

  data () {
    return {
      openPop: false,
      record: [],
      pageIndex: 1,
      orderBy: 'userName'
    }
  },
  components: {
    labelTag,
    Popup,
    Pagination
  },
  computed: {
    mode () {
      return this.$route.params.mode
    }
  },
  mounted () {
    console.log(this.$route.params.mode)
  },
  methods: {
    goPage (id) {
      this.$router.push({name: 'Record.member', params: { mode: this.mode, country: this.record.countryId, id: id, lesson: this.record.lessonId !== '' ? this.record.lessonId : 0 }})
    },
    getRecord (value) {
      this.record = value
    },
    updatePage (page) {
      this.pageIndex = page
    },
    doOrder (order) {
      this.orderBy = order
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .order-btn {
    color: rgb(1, 1, 187);
  }
</style>


// WEBPACK FOOTER //
// RecordSummary.vue?3af63150